import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ChatMessage = {
  role: 'user' | 'assistant';
  content?: string;
  type?: 'text' | 'proposed_action';
  action?: string;
  summary?: string;
  payload?: any;
};

interface AIState {
  isWidgetOpen: boolean;
  isWidgetMinimized: boolean;
  chatHistory: ChatMessage[];
  userRole: string;
  
  setIsWidgetOpen: (open: boolean) => void;
  setIsWidgetMinimized: (minimized: boolean) => void;
  addMessage: (msg: ChatMessage) => void;
  clearChat: () => void;
  setUserRole: (role: string) => void;
}

export const useAIStore = create<AIState>()(
  persist(
    (set) => ({
      isWidgetOpen: false,
      isWidgetMinimized: false,
      chatHistory: [],
      userRole: 'admin',

      setIsWidgetOpen: (isWidgetOpen) => set({ isWidgetOpen }),
      setIsWidgetMinimized: (isWidgetMinimized) => set({ isWidgetMinimized }),
      addMessage: (msg) => set((state) => ({ 
        chatHistory: [...state.chatHistory, msg].slice(-30) // Keep last 30 messages
      })),
      clearChat: () => set({ chatHistory: [] }),
      setUserRole: (userRole) => set({ userRole }),
    }),
    {
      name: 'wonder-herbals-ai-chat',
      partialize: (state) => ({ chatHistory: state.chatHistory }), // Only persist chat history
    }
  )
);
